import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["inspiration-tabs", {'inspiration-tabs--sticky': _ctx.showStickyTab && _ctx.stickyState}])
  }, [
    _renderSlot(_ctx.$slots, "tabs"),
    _cache[0] || (_cache[0] = _createTextVNode()),
    (_ctx.showStickyTab)
      ? _renderSlot(_ctx.$slots, "sticky-tab", { key: 0 })
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}